import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConstantsService } from './api-constants.service';
import {
  BeneficiaryCategory,
  CreateBeneficiaryCategoryParams,
  ListBeneficiaryCategoryRequestParams,
  UpdateBeneficiaryCategoryParams
} from '~core/models/beneficiary-category.models';
import { Observable } from 'rxjs';
import { Pagination } from '~core/models/core.models';

@Injectable()
export class BeneficiaryCategoryService {
  private _http = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  private _buildUrl(
    taxExemptionTypeId: string,
    derogatoryRegimeId: string,
    id?: string
  ): string {
    const baseUrl = `${this._apiConstantsService.taxExemptionTypeUrl}/${taxExemptionTypeId}/derogatory-regimes/${derogatoryRegimeId}/beneficiary-categories`;
    return id ? `${baseUrl}/${id}` : baseUrl;
  }

  list(
    taxExemptionTypeId: string,
    derogatoryRegimeId: string,
    params?: ListBeneficiaryCategoryRequestParams
  ): Observable<Pagination<BeneficiaryCategory>> {
    return this._http.get<Pagination<BeneficiaryCategory>>(
      this._buildUrl(taxExemptionTypeId, derogatoryRegimeId),
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  read(
    taxExemptionTypeId: string,
    derogatoryRegimeId: string,
    id: string
  ): Observable<BeneficiaryCategory> {
    return this._http.get<BeneficiaryCategory>(
      this._buildUrl(taxExemptionTypeId, derogatoryRegimeId, id)
    );
  }

  create(
    taxExemptionTypeId: string,
    derogatoryRegimeId: string,
    payload: CreateBeneficiaryCategoryParams
  ): Observable<BeneficiaryCategory> {
    return this._http.post<BeneficiaryCategory>(
      this._buildUrl(taxExemptionTypeId, derogatoryRegimeId),
      payload
    );
  }

  update(
    taxExemptionTypeId: string,
    derogatoryRegimeId: string,
    id: string,
    payload: UpdateBeneficiaryCategoryParams
  ): Observable<BeneficiaryCategory> {
    return this._http.patch<BeneficiaryCategory>(
      this._buildUrl(taxExemptionTypeId, derogatoryRegimeId, id),
      payload
    );
  }

  delete(
    taxExemptionTypeId: string,
    derogatoryRegimeId: string,
    id: string
  ): Observable<unknown> {
    return this._http.delete(
      this._buildUrl(taxExemptionTypeId, derogatoryRegimeId, id)
    );
  }
}
